import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import type { QueryClient } from '@tanstack/react-query';
import type { Me } from '@rm/shared';
import { Center, Stack, Text, Title, Button } from '@mantine/core';

export interface RouterContext {
  queryClient: QueryClient;
  /** Resolved once at boot from `GET /api/me`; null when signed out. */
  session: Me | null;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: () => <Outlet />,
  notFoundComponent: () => (
    <Center h="100vh" p="xl">
      <Stack align="center" gap="xs">
        <Title order={2}>Page not found</Title>
        <Text c="dimmed">That link does not point anywhere on this board.</Text>
        <Button component="a" href="/" mt="md" variant="light">
          Back to the board
        </Button>
      </Stack>
    </Center>
  ),
  errorComponent: ({ error }) => (
    <Center h="100vh" p="xl">
      <Stack align="center" gap="xs" maw={480}>
        <Title order={2}>Something went wrong</Title>
        <Text c="dimmed" ta="center">
          {error instanceof Error ? error.message : 'An unexpected error occurred.'}
        </Text>
        <Button onClick={() => window.location.reload()} mt="md" variant="light">
          Reload
        </Button>
      </Stack>
    </Center>
  ),
});
